import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Mail } from '../models/mail.interface';
import { firestore } from '../../firebase'; // for cloud firestore
import { DocumentReference, addDoc, collection } from 'firebase/firestore';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor() {}

  sendMail(mail: Mail): Promise<DocumentReference> {
    return addDoc(collection(firestore, environment.firestoreCollectionMails), mail);
  }
}
